import { render, staticRenderFns } from "./slider-comments.vue?vue&type=template&id=2e2aa7c2&scoped=true&lang=html"
import script from "./slider-comments.vue?vue&type=script&lang=js"
export * from "./slider-comments.vue?vue&type=script&lang=js"
import style0 from "./slider-comments.vue?vue&type=style&index=0&id=2e2aa7c2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2aa7c2",
  null
  
)

export default component.exports